import { useBreakpointValue, useDisclosure } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import propTypes from 'prop-types';
import React from 'react';
import { useAuth } from '../providers/auth';
import Header from '@outdoorly/header';
import MobileHeader from '@outdoorly/mobile-header';
import { useCheckout } from '../hooks/use-checkout';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { BreadcrumbJsonLd } from 'next-seo';

const LazyMobileMenu = dynamic(() => import('@outdoorly/mobile-menu'));
const LazySearch = dynamic(() => import('./search/search-modal'));

const GET_NAV = gql`
  query GetNav {
    shop {
      navigation {
        main {
          name
          id
          jsonContent
        }
      }
    }
  }
`;

export const ResponsiveNav = () => {
  const { data } = useQuery(GET_NAV);

  const menuItems = data?.shop.navigation.main?.jsonContent
    ? JSON.parse(data?.shop.navigation.main?.jsonContent)
    : [];

  const header = useBreakpointValue({ base: 'mobile', lg: 'large' });

  const { onClose, isOpen, onToggle } = useDisclosure();
  const {
    onClose: onCloseSearch,
    isOpen: isSearchOpen,
    onOpen: onOpenSearch,
  } = useDisclosure();

  const { isAuthed, logout } = useAuth();

  const { checkout } = useCheckout();

  const cartItems = checkout?.quantity;

  return (
    <>
      <BreadcrumbJsonLd
        itemListElements={menuItems.map((item, index) => ({
          position: index + 1,
          name: item?.name,
          item: item?.linked_object?.url,
        }))}
      />
      {header === 'mobile' ? (
        <>
          <MobileHeader
            onMenuToggle={onToggle}
            cartItems={cartItems}
            onSearch={onOpenSearch}
          />
          <LazyMobileMenu
            menuItems={menuItems}
            isOpen={isOpen}
            onClose={onClose}
            isAuthed={isAuthed}
            onLogout={logout}
          />
        </>
      ) : (
        <Header
          menuItems={menuItems}
          isAuthed={isAuthed}
          cartItems={cartItems}
          onSearch={onOpenSearch}
        />
      )}
      <LazySearch isOpen={isSearchOpen} onClose={onCloseSearch} />
    </>
  );
};

ResponsiveNav.propTypes = {
  menuItems: propTypes.array,
};

export default ResponsiveNav;
